import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useAdmin } from '../../hooks/useAdmin';

interface AdminRouteProps {
  children: ReactNode;
  fallback?: ReactNode;
}

export default function AdminRoute({ children, fallback }: AdminRouteProps) {
  const { isAdmin } = useAdmin();

  if (!isAdmin) {
    return (
      fallback || (
        <div className="min-h-screen flex items-center justify-center theme-surface">
          <div className="text-center p-8 max-w-md">
            <div className="mb-4">
              <svg className="h-16 w-16 text-red-500 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4.5c-.77-.833-2.694-.833-3.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold theme-text mb-2">Access Denied</h2>
            <p className="theme-text-muted mb-6">
              You don't have permission to access this area. Admin access is required.
            </p>
            <Link 
              to="/" 
              className="inline-block px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
            >
              Go to Login
            </Link>
          </div>
        </div>
      )
    );
  }

  return <>{children}</>;
}